export default {
  loginButton: 'Sign In',
};
